import * as React from "react";
import {cx} from "emotion";

import "./billing-form-display.scss";

import {bindInput}               from "@Common/react/bind-input";
import {cs}                      from "@Common/react/chain-services";
import {Select}                  from "@Common/ui-components/heavy/common/design2/select/select";
import {unique}                  from "@Common/utils/collections";
import {chain}                   from "@Common/utils/fs";
import {isEmpty, keepOnly, omit} from "@Common/utils/objects";

export const BillingFormDisplay = ({apiErrors, getField, onApply, account, showErrors, pendingChangeHighlighter}) => cs(
    () => (
        <div className="billing-form-display-5ha">
            {account.fields.comments && (
                <div className="comments">
                    <div className="title" xd-qa-type="label" xd-qa-name={account.fields.comments.label}>
                        {account.fields.comments.label}

                        {account.fields.comments.required && (
                            <div className="required">
                                *
                            </div>
                        )}
                    </div>

                    {(() => {
                        const ff = getField("comments");
                        return (
                            <textarea {...{
                                ...bindInput(ff.state),
                                placeholder: "Enter billing comment",
                                className: cx({hasError: showErrors && ff.error}),
                                "xd-qa-type": "textarea",
                                "xd-qa-name": account.fields.comments.label
                            }} />
                        );
                    })()}
                </div>
            )}

            {chain(
                omit(account.fields, ["comments"]),
                (fields) => !isEmpty(fields) && (
                    <div className="fields">
                        <div className="title">
                            {account.fieldsTitle}
                        </div>

                        <div className="content">
                            {!!apiErrors?.length && (
                                <div className="api-errors">
                                    {chain(
                                        unique(apiErrors, (e) => JSON.stringify(keepOnly(e, ["error", "field"]))),
                                        (errors) => errors.map((apiError, i) => (
                                            <div className="error" key={i}>
                                                <div className="icon">
                                                    <i className="fa fa-warning"/>
                                                </div>
                                                <div className="text">
                                                    <div className="line">
                                                        Your "{account.fields[apiError.field].label}" has error:
                                                    </div>
                                                    <div className="line">
                                                        {apiError.error}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            )}

                            {Object.keys(fields).map((fieldName) => {

                                const field = chain(
                                    account.fields[fieldName],
                                    (_) => ({
                                        ..._,
                                        ..._[fieldName + "Dropdown"] && {
                                            type: "array",
                                            values: _[fieldName + "Dropdown"].split(","),
                                        },
                                    })
                                );
                                const ff = getField(fieldName);

                                return (
                                    <div className="field" key={fieldName}>
                                        <div className="title">
                                            {field.label}

                                            {field.required && (
                                                <div className="required">
                                                    *
                                                </div>
                                            )}
                                        </div>

                                        {field.instructions && (
                                            <div className="instructions">
                                                {field.instructions}
                                            </div>
                                        )}


                                        {(field.type === "Number" || field.type === "string") ? (
                                            <input {...{
                                                ...bindInput(ff.state),
                                                className: cx({hasError: showErrors && (ff.error || ff.apiError)}),
                                                maxLength: 80,
                                                "xd-qa-type": "text_field",
                                                "xd-qa-name": field.label,
                                            }} />
                                        ) : (
                                            Select({
                                                list: field.values,
                                                itemToLabel: v=>v,
                                                isSelected: v=>ff.state.value === v,
                                                onChange: v=>ff.state.onChange(v),
                                                style: {
                                                    color: (showErrors && (ff.error || ff.apiError)) && "danger",
                                                },
                                            })
                                        )}

                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )
            )}

            <div className="footer">
                <button {...{
                    className: pendingChangeHighlighter.css,
                    disabled: true,
                    ...onApply && {
                        disabled: false,
                        onClick: onApply,
                    },
                    "xd-qa-type": "button",
                    "xd-qa-name": "Apply",
                }}>
                    Apply
                </button>
            </div>
        </div>
    ),
);